import { render, staticRenderFns } from "./ClockChangeBanner.vue?vue&type=template&id=c41e911a"
import script from "./ClockChangeBanner.vue?vue&type=script&lang=js"
export * from "./ClockChangeBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClockChangeDial: require('/app/components/ClockChangeDial.vue').default})
